export default __webpack_public_path__ + "static/media/curbSuiteLogoBlue.56ba700f.svg";